import type { AssetTypeStatus } from "@overmap-ai/common"

import { FilterModifier } from "./FilterModifier"

export const AssetTypeStatusEqualsFilterModifier = FilterModifier.create<
	AssetTypeStatus["uuid"],
	AssetTypeStatus["uuid"]
>({
	id: "asset-type-status-equals",
	getApplyFn: (filterValue) => (value) => {
		return value === filterValue
	},
	render: () => "is",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const AssetTypeStatusNotEqualsFilterModifier = FilterModifier.create<
	AssetTypeStatus["uuid"],
	AssetTypeStatus["uuid"]
>({
	id: "asset-type-status-not-equals",
	getApplyFn: (filterValue) => (value) => {
		return value !== filterValue
	},
	render: () => "is not",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const AssetTypeStatusIncludesFilterModifier = FilterModifier.create<
	AssetTypeStatus["uuid"],
	AssetTypeStatus["uuid"][]
>({
	id: "asset-type-status-includes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return filterValueSet.has(value)
		}
	},
	render: () => "is any of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})

export const AssetTypeStatusExcludesFilterModifier = FilterModifier.create<
	AssetTypeStatus["uuid"],
	AssetTypeStatus["uuid"][]
>({
	id: "asset-type-status-excludes",
	getApplyFn: (filterValue) => {
		const filterValueSet = new Set(filterValue)
		return (value) => {
			return !filterValueSet.has(value)
		}
	},
	render: () => "is none of",
	serialize: (filterValue) => filterValue,
	deserialize: (filterValue) => filterValue,
})
